const __WEBPACK_NAMESPACE_OBJECT__ = require("@adyen/adyen-web");